<template>
  <v-container></v-container>
</template>

<script>
  import { apiResource } from '@/util/resources'

  export default {
    created () {
      this.verifyPayment()
    },
    methods: {
      verifyPayment () {
        let redirectUrl = this.$store.getters.paymentRedirectUrl
        if (redirectUrl === null || redirectUrl === '/pay-all') {
          redirectUrl = '/front-page'
        } else {
          this.$store.commit('setPaymentRedirectUrl', null)
        }

        apiResource.get('api/payments/confirm', { params: this.$route.query }).then((response) => {
          if (response.data.status === 0) {
            if (response.data.responseObject.status === true) {
              this.$store.commit('setPaymentPending', response.data.responseObject)
              // this.$store.commit('setMessage', { type: 'primary', text: 'payment.successful', translate: true, clickToDismiss: true })
              this.$matomo && this.$matomo.trackEvent("Payment", "Payment", "Payment complete")
            } else {
              this.$store.commit('setMessage', { type: 'info', text: 'payment.canceled', translate: true, clickToDismiss: true })
              this.$matomo && this.$matomo.trackEvent("Payment", "Payment", "Payment canceled")
            }
          } else {
            this.$store.commit('setMessage', { type: 'error', text: response.data.ErrorCode, translate: true, clickToDismiss: true })
            this.$matomo && this.$matomo.trackEvent("Payment", "Payment", "Payment failed")
          }
          this.$router.push(redirectUrl)
        }).catch((errorResponse) => {
          this.$store.commit('setMessage', { type: 'error', text: errorResponse.data.ErrorCode, translate: true, clickToDismiss: true })
          this.$store.commit('setLoading', false)
          this.$router.push(redirectUrl)
        })
      }
    }
  }
</script>
